<template>
  <div class="marginBT">
    <div class="marginLR center titlesContainer">
      <h2 class="titles">{{ this.$t("datos.clienteTitulo") }}</h2>
      <p class="subtitles">{{ this.$t("datos.textos.clienteSubtitulo") }}</p>
    </div>

    <div class="whitePanel marginBottom">
      <div>
        <p class="smallBlueText">
          <i class="pi pi-info" />{{
            this.$t("datos.textos.clienteObligatorios")
          }}
        </p>
      </div>

      <div class="grid">
        <div class="col-12">
          <p>{{ this.$t("datos.textos.clienteRelacion") }}</p>
          <p></p>
          <p class="greyText">
            <RadioButton
              name="self"
              @change="onChangeEvent(true)"
              value="true"
              v-model="datosCliente.actuoEnPropioNombre"
            />
            {{ this.$t("datos.textos.clienteActuoPropio") }}
          </p>
          <p class="greyText">
            <RadioButton
              name="other"
              @change="onChangeEvent(false)"
              value="false"
              v-model="datosCliente.actuoEnPropioNombre"
            />
            {{ this.$t("datos.textos.clienteRepresentoOtraPersona") }}
          </p>
          <small v-if="validation.actOnOwnName === false" class="p-invalid">{{
            this.$t("datos.messages.error.campoIncorrecto")
          }}</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DatosCliente",
  props: {
    clientData: {
      type: Object,
      required: true,
    },
    paid: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      datosCliente: this.clientData,
      isAuthorized: false,
      isPaid: this.paid,
      validation: {
        actOnOwnName: true,
      },
    };
  },
  methods: {
    hasFormErrors() {
      return !this.validation.actOnOwnName;
    },
    validateForm() {
      this.validateActOnOwnName();
    },
    validateActOnOwnName() {
      this.datosCliente.actuoEnPropioNombre
        ? (this.validation.actOnOwnName = true)
        : (this.validation.actOnOwnName = false);
    },
    onChangeEvent(value) {
      this.$emit("actOnOwnName", value);
    },
  },
  watch: {
    paid(newValue) {
      this.isPaid = newValue;
    },
    clientData(newValue) {
      this.datosCliente = newValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.titlesContainer {
  padding-bottom: 1.25em !important;
}
</style>